module.exports = __webpack_public_path__ + "static/img/Frame 37638@2x.d74ab37.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/pc/Frame 37638@2x.png
// module id = OMMD
// module chunks = 1